import { render } from "./BetterAperture.vue?vue&type=template&id=779fea67&scoped=true&ts=true"
import script from "./BetterAperture.vue?vue&type=script&lang=ts"
export * from "./BetterAperture.vue?vue&type=script&lang=ts"

import "./BetterAperture.vue?vue&type=style&index=0&id=779fea67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779fea67"]])

export default __exports__